import { useMemo, useState } from 'react';
import './HeartAttack.css';
import { commitNumberInput, clamp, handleArrowCommit, handleRangeIntChange } from './helpers.js';
import FitFacts from './FitFacts.js';

const isBetween = (num, min, max) => {
	const value = parseInt(num, 10);
	const lower = parseInt(min, 10);
	const upper = parseInt(max, 10);

	return lower <= value && upper >= value;
};

const getAgePoints = (age, gender) => {
	let points = 0;

	if (gender === 'Female') {
		if (isBetween(age, 20, 34)) { points += -7; }
		if (isBetween(age, 35, 39)) { points += -3; }
		if (isBetween(age, 40, 44)) { points += 0; }
		if (isBetween(age, 45, 49)) { points += 3; }
		if (isBetween(age, 50, 54)) { points += 6; }
		if (isBetween(age, 55, 59)) { points += 8; }
		if (isBetween(age, 60, 64)) { points += 10; }
		if (isBetween(age, 65, 69)) { points += 12; }
		if (isBetween(age, 70, 74)) { points += 14; }
		if (isBetween(age, 75, 100)) { points += 16; }
		return points;
	}

	if (isBetween(age, 20, 34)) { points += -9; }
	if (isBetween(age, 35, 39)) { points += -4; }
	if (isBetween(age, 40, 44)) { points += 0; }
	if (isBetween(age, 45, 49)) { points += 3; }
	if (isBetween(age, 50, 54)) { points += 6; }
	if (isBetween(age, 55, 59)) { points += 8; }
	if (isBetween(age, 60, 64)) { points += 10; }
	if (isBetween(age, 65, 69)) { points += 11; }
	if (isBetween(age, 70, 74)) { points += 12; }
	if (isBetween(age, 75, 100)) { points += 13; }

	return points;
};

const getCholesterolPoints = (age, gender, cholesterol) => {
	let points = 0;

	if (gender === 'Female') {
		if (isBetween(age, 20, 30)) {
			if (isBetween(cholesterol, 0, 159)) { points += 0; }
			if (isBetween(cholesterol, 161, 199)) { points += 4; }
			if (isBetween(cholesterol, 200, 239)) { points += 8; }
			if (isBetween(cholesterol, 240, 279)) { points += 11; }
			if (isBetween(cholesterol, 280, 450)) { points += 13; }
		}
		if (isBetween(age, 40, 49)) {
			if (isBetween(cholesterol, 0, 159)) { points += 0; }
			if (isBetween(cholesterol, 160, 199)) { points += 3; }
			if (isBetween(cholesterol, 200, 239)) { points += 6; }
			if (isBetween(cholesterol, 240, 279)) { points += 8; }
			if (isBetween(cholesterol, 280, 450)) { points += 10; }
		}
		if (isBetween(age, 50, 59)) {
			if (isBetween(cholesterol, 0, 159)) { points += 0; }
			if (isBetween(cholesterol, 160, 199)) { points += 2; }
			if (isBetween(cholesterol, 200, 239)) { points += 4; }
			if (isBetween(cholesterol, 240, 279)) { points += 5; }
			if (isBetween(cholesterol, 280, 450)) { points += 7; }
		}
		if (isBetween(age, 60, 69)) {
			if (isBetween(cholesterol, 0, 159)) { points += 0; }
			if (isBetween(cholesterol, 160, 199)) { points += 1; }
			if (isBetween(cholesterol, 200, 239)) { points += 2; }
			if (isBetween(cholesterol, 240, 279)) { points += 3; }
			if (isBetween(cholesterol, 280, 450)) { points += 4; }
		}
		if (isBetween(age, 70, 100)) {
			if (isBetween(cholesterol, 0, 159)) { points += 0; }
			if (isBetween(cholesterol, 160, 199)) { points += 1; }
			if (isBetween(cholesterol, 200, 239)) { points += 1; }
			if (isBetween(cholesterol, 240, 279)) { points += 2; }
			if (isBetween(cholesterol, 280, 450)) { points += 2; }
		}
		return points;
	}

	if (isBetween(age, 20, 30)) {
		if (isBetween(cholesterol, 0, 159)) { points += 0; }
		if (isBetween(cholesterol, 161, 199)) { points += 4; }
		if (isBetween(cholesterol, 200, 239)) { points += 7; }
		if (isBetween(cholesterol, 240, 279)) { points += 9; }
		if (isBetween(cholesterol, 280, 450)) { points += 11; }
	}
	if (isBetween(age, 40, 49)) {
		if (isBetween(cholesterol, 0, 159)) { points += 0; }
		if (isBetween(cholesterol, 160, 199)) { points += 3; }
		if (isBetween(cholesterol, 200, 239)) { points += 5; }
		if (isBetween(cholesterol, 240, 279)) { points += 5; }
		if (isBetween(cholesterol, 280, 450)) { points += 8; }
	}
	if (isBetween(age, 50, 59)) {
		if (isBetween(cholesterol, 0, 159)) { points += 0; }
		if (isBetween(cholesterol, 160, 199)) { points += 2; }
		if (isBetween(cholesterol, 200, 239)) { points += 3; }
		if (isBetween(cholesterol, 240, 279)) { points += 4; }
		if (isBetween(cholesterol, 280, 450)) { points += 5; }
	}
	if (isBetween(age, 60, 69)) {
		if (isBetween(cholesterol, 0, 159)) { points += 0; }
		if (isBetween(cholesterol, 160, 199)) { points += 1; }
		if (isBetween(cholesterol, 200, 239)) { points += 1; }
		if (isBetween(cholesterol, 240, 279)) { points += 2; }
		if (isBetween(cholesterol, 280, 450)) { points += 3; }
	}
	if (isBetween(age, 70, 100)) {
		if (isBetween(cholesterol, 0, 159)) { points += 0; }
		if (isBetween(cholesterol, 160, 199)) { points += 0; }
		if (isBetween(cholesterol, 200, 239)) { points += 0; }
		if (isBetween(cholesterol, 240, 279)) { points += 1; }
		if (isBetween(cholesterol, 280, 450)) { points += 1; }
	}

	return points;
};

const getSmokerPoints = (age, gender) => {
	let points = 0;

	if (gender === 'Female') {
		if (isBetween(age, 20, 39)) { points += 9; }
		if (isBetween(age, 40, 49)) { points += 7; }
		if (isBetween(age, 50, 59)) { points += 4; }
		if (isBetween(age, 60, 69)) { points += 2; }
		if (isBetween(age, 70, 100)) { points += 1; }
		return points;
	}

	if (isBetween(age, 20, 39)) { points += 8; }
	if (isBetween(age, 40, 49)) { points += 5; }
	if (isBetween(age, 50, 59)) { points += 3; }
	if (isBetween(age, 60, 69)) { points += 1; }
	if (isBetween(age, 70, 100)) { points += 1; }

	return points;
};

const getHDLPoints = (hdl) => {
	let points = 0;

	if (isBetween(hdl, 0, 40)) { points += 2; }
	if (isBetween(hdl, 40, 49)) { points += 1; }
	if (isBetween(hdl, 50, 59)) { points += 0; }
	if (isBetween(hdl, 60, 100)) { points += -1; }

	return points;
};

const getBPPoints = (gender, bp, meds) => {
	let points = 0;

	if (gender === 'Female') {
		if (meds) {
			if (isBetween(bp, 0, 119)) { points += 0; }
			if (isBetween(bp, 120, 129)) { points += 3; }
			if (isBetween(bp, 130, 139)) { points += 4; }
			if (isBetween(bp, 140, 159)) { points += 5; }
			if (isBetween(bp, 160, 250)) { points += 6; }
		}
		else {
			if (isBetween(bp, 0, 119)) { points += 0; }
			if (isBetween(bp, 120, 129)) { points += 1; }
			if (isBetween(bp, 130, 139)) { points += 2; }
			if (isBetween(bp, 140, 159)) { points += 3; }
			if (isBetween(bp, 160, 250)) { points += 4; }
		}

		return points;
	}

	if (meds) {
		if (isBetween(bp, 0, 119)) { points += 0; }
		if (isBetween(bp, 120, 129)) { points += 1; }
		if (isBetween(bp, 130, 139)) { points += 2; }
		if (isBetween(bp, 140, 159)) { points += 2; }
		if (isBetween(bp, 160, 250)) { points += 3; }
	}
	else {
		if (isBetween(bp, 0, 119)) { points += 0; }
		if (isBetween(bp, 120, 129)) { points += 0; }
		if (isBetween(bp, 130, 139)) { points += 1; }
		if (isBetween(bp, 140, 159)) { points += 1; }
		if (isBetween(bp, 160, 250)) { points += 2; }
	}

	return points;
};

const getPercentInt = (gender, points) => {
	let percentInt = 0;

	if (gender === 'Female') {
		if (isBetween(points, 0, 8)) { percentInt = 0; }
		if (isBetween(points, 9, 12)) { percentInt = 1; }
		if (isBetween(points, 13, 14)) { percentInt = 2; }
		if (points === 15) { percentInt = 3; }
		if (points === 16) { percentInt = 4; }
		if (points === 17) { percentInt = 5; }
		if (points === 18) { percentInt = 6; }
		if (points === 19) { percentInt = 8; }
		if (points === 20) { percentInt = 11; }
		if (points === 21) { percentInt = 14; }
		if (points === 22) { percentInt = 17; }
		if (points === 23) { percentInt = 22; }
		if (points === 24) { percentInt = 27; }
		if (isBetween(points, 25, 100)) { percentInt = 30; }
		return percentInt;
	}

	if (points === 0) { percentInt = 0; }
	if (isBetween(points, 1, 4)) { percentInt = 1; }
	if (isBetween(points, 5, 6)) { percentInt = 2; }
	if (points === 7) { percentInt = 3; }
	if (points === 8) { percentInt = 4; }
	if (points === 9) { percentInt = 5; }
	if (points === 10) { percentInt = 6; }
	if (points === 11) { percentInt = 8; }
	if (points === 12) { percentInt = 10; }
	if (points === 13) { percentInt = 12; }
	if (points === 14) { percentInt = 16; }
	if (points === 15) { percentInt = 20; }
	if (points === 16) { percentInt = 25; }
	if (isBetween(points, 17, 100)) { percentInt = 30; }

	return percentInt;
};

export default function HeartAttack() {
	const [age, setAge] = useState(43);
	const [cholesterol, setCholesterol] = useState(307);
	const [hdl, setHdl] = useState(40);
	const [bp, setBp] = useState(180);
	const [ageInput, setAgeInput] = useState('43');
	const [cholesterolInput, setCholesterolInput] = useState('307');
	const [hdlInput, setHdlInput] = useState('40');
	const [bpInput, setBpInput] = useState('180');
	const [gender, setGender] = useState('Female');
	const [meds, setMeds] = useState('No');
	const [smoker, setSmoker] = useState('No');

	const percentInt = useMemo(() => {
		let points = 0;
		points += getAgePoints(age, gender);
		points += getCholesterolPoints(age, gender, cholesterol);
		points += smoker === 'Yes' ? getSmokerPoints(age, gender) : 0;
		points += getHDLPoints(hdl, gender);
		points += getBPPoints(gender, bp, meds === 'Yes');
		return getPercentInt(gender, points);
	}, [age, cholesterol, hdl, bp, gender, meds, smoker]);

	const riskIntText = percentInt === 0 ? 'Less than 1 ' : (percentInt === 30 ? 'Over 30 ' : percentInt.toString());
	const riskResult = percentInt === 0 ? '<1%' : (percentInt === 30 ? '>30%' : `${percentInt}%`);

	return (
		<div className="calc-container-scroller">
			<div className="calc-container-scroller-inner">
				<div className="calculator-wrap">
					<h3>Risk Assessment Calculator</h3>

					<div className="calculator-row">
						<div className="range-row">
							<div className="range-row__input-wrap">
								<input
									id="range-age"
									type="range"
									min="10"
									max="100"
									value={age}
									onChange={(e) => handleRangeIntChange(e, setAge, setAgeInput)}
								/>
							</div>

							<div className="range-row__result-wrap">
								<label htmlFor="result-age">Age: </label>
								<input
									type="number"
									id="result-age"
									name="result-age"
									value={ageInput}
									onChange={(e) => setAgeInput(e.target.value)}
									onKeyUp={(e) => handleArrowCommit(e, 10, 100, age, setAge, setAgeInput)}
									onBlur={() => commitNumberInput(ageInput, 10, 100, age, setAge, setAgeInput)}
								/>
							</div>
						</div>
					</div>

					<div className="calculator-row">
						<div className="radio-row">
							<div className="radio-row__input-wrap">
								<label className={`radio-label radio-img-mask ${gender === 'Male' ? 'active' : ''}`} htmlFor="option-gender-male">
									<input
										id="option-gender-male"
										name="option-gender"
										type="radio"
										value="Male"
										checked={gender === 'Male'}
										onChange={(e) => setGender(e.target.value)}
									/>
									<img src="/images/webcontent/assets/education-resources/lifestyle/acefit/iconMaleSmall.png" style={{ height: '30px' }} alt="Male" />
								</label>

								<label className={`radio-label radio-img-mask ${gender === 'Female' ? 'active' : ''}`} htmlFor="option-gender-female">
									<input
										id="option-gender-female"
										name="option-gender"
										type="radio"
										value="Female"
										checked={gender === 'Female'}
										onChange={(e) => setGender(e.target.value)}
									/>
									<img src="/images/webcontent/assets/education-resources/lifestyle/acefit/iconFemaleSmall.png" style={{ height: '30px' }} alt="Female" />
								</label>
							</div>

							<div className="radio-row__result-wrap">
								<label htmlFor="result-gender">Gender: </label>
								<input type="text" id="result-gender" name="result-gender" readOnly value={gender} />
							</div>
						</div>
					</div>

					<div className="calculator-row">
						<h4 className="calculator-row-title">Total Cholesterol</h4>

						<div className="range-row">
							<div className="range-row__input-wrap">
								<input
									id="range-cholesterol"
									type="range"
									min="130"
									max="450"
									value={cholesterol}
									onChange={(e) => handleRangeIntChange(e, setCholesterol, setCholesterolInput)}
								/>
							</div>

							<div className="range-row__result-wrap">
								<label htmlFor="result-cholesterol">mg/dL: </label>
								<input
									type="number"
									id="result-cholesterol"
									name="result-cholesterol"
									value={cholesterolInput}
									onChange={(e) => setCholesterolInput(e.target.value)}
									onKeyUp={(e) => handleArrowCommit(e, 130, 450, cholesterol, setCholesterol, setCholesterolInput)}
									onBlur={() => commitNumberInput(cholesterolInput, 130, 450, cholesterol, setCholesterol, setCholesterolInput)}
								/>
							</div>
						</div>
					</div>

					<div className="calculator-row">
						<h4 className="calculator-row-title">HDL aka "Good" Cholestorol:</h4>

						<div className="range-row">
							<div className="range-row__input-wrap">
								<input
									id="range-hdl"
									type="range"
									min="20"
									max="100"
									value={hdl}
									onChange={(e) => handleRangeIntChange(e, setHdl, setHdlInput)}
								/>
							</div>

							<div className="range-row__result-wrap">
								<label htmlFor="result-hdl">mg/dL: </label>
								<input
									type="number"
									id="result-hdl"
									name="result-hdl"
									value={hdlInput}
									onChange={(e) => setHdlInput(e.target.value)}
									onKeyUp={(e) => handleArrowCommit(e, 20, 100, hdl, setHdl, setHdlInput)}
									onBlur={() => commitNumberInput(hdlInput, 20, 100, hdl, setHdl, setHdlInput)}
								/>
							</div>
						</div>
					</div>

					<div className="calculator-row">
						<h4 className="calculator-row-title">Systolic Blood Pressure:</h4>

						<div className="range-row">
							<div className="range-row__input-wrap">
								<input
									id="range-bp"
									type="range"
									min="90"
									max="250"
									value={bp}
									onChange={(e) => handleRangeIntChange(e, setBp, setBpInput)}
								/>
							</div>

							<div className="range-row__result-wrap">
								<label htmlFor="result-bp">SBP: </label>
								<input
									type="number"
									id="result-bp"
									name="result-bp"
									value={bpInput}
									onChange={(e) => setBpInput(e.target.value)}
									onKeyUp={(e) => handleArrowCommit(e, 90, 250, bp, setBp, setBpInput)}
									onBlur={() => commitNumberInput(bpInput, 90, 250, bp, setBp, setBpInput)}
								/>
							</div>
						</div>
					</div>

					<div className="calculator-row">
						<h4 className="calculator-row-title spc-m-b-half">Are you currently on high blood pressure medication?</h4>

						<div className="radio-row">
							<div className="radio-row__input-wrap">
								<label className={`radio-label ${meds === 'Yes' ? 'active' : ''}`} htmlFor="option-meds-yes">
									<input id="option-meds-yes" name="option-meds" type="radio" value="Yes" checked={meds === 'Yes'} onChange={(e) => setMeds(e.target.value)} /> Yes
								</label>

								<label className={`radio-label ${meds === 'No' ? 'active' : ''}`} htmlFor="option-meds-no">
									<input id="option-meds-no" name="option-meds" type="radio" value="No" checked={meds === 'No'} onChange={(e) => setMeds(e.target.value)} /> No
								</label>
							</div>

							<div className="radio-row__result-wrap">
								<input type="text" id="result-meds" name="result-meds" readOnly value={meds} />
							</div>
						</div>
					</div>

					<div className="calculator-row">
						<h4 className="calculator-row-title spc-m-b-half">Have you smoked any cigarettes in the past month?</h4>

						<div className="radio-row">
							<div className="radio-row__input-wrap">
								<label className={`radio-label radio-img-mask ${smoker === 'Yes' ? 'active' : ''}`} htmlFor="option-smoker-yes">
									<input id="option-smoker-yes" name="option-smoker" type="radio" value="Yes" checked={smoker === 'Yes'} onChange={(e) => setSmoker(e.target.value)} />
									<img src="/images/webcontent/assets/education-resources/lifestyle/acefit/smoker.png" style={{ width: '70px' }} alt="Smoker" />
								</label>

								<label className={`radio-label radio-img-mask ${smoker === 'No' ? 'active' : ''}`} htmlFor="option-smoker-no">
									<input id="option-smoker-no" name="option-smoker" type="radio" value="No" checked={smoker === 'No'} onChange={(e) => setSmoker(e.target.value)} />
									<img src="/images/webcontent/assets/education-resources/lifestyle/acefit/nonsmoker.png" style={{ width: '70px' }} alt="Non-smoker" />
								</label>
							</div>

							<div className="radio-row__result-wrap">
								<input type="text" id="result-smoker" name="result-smoker" readOnly value={smoker} />
							</div>
						</div>
					</div>

					<hr />

					<div>
						<h4 className="results-row__label">Your Risk Factor</h4>
						<span style={{ fontSize: '12px' }}>
							<span className="text-wsp-nowrap">Low: Under 10% | </span>
							<span className="text-wsp-nowrap">Medium: 10 to 20% | </span>
							<span className="text-wsp-nowrap">High: Over 20%</span>
						</span>
						<progress id="riskfactor" max="30" value={percentInt}></progress>
					</div>

					<div className="results-row">
						<h4 className="results-row__label">
							<span id="riskint">{riskIntText} </span>
							out of 100 people with this level of risk will have a heart attack in the next 10 years.
						</h4>

						<input type="text" className="results-row__value" readOnly id="resultRiskFactor" name="resultRiskFactor" value={riskResult} />
					</div>

                    <FitFacts
                        items={[
                            {
                                link: '/images/webcontent/assets/education-resources/lifestyle/fitfacts/pdfs/fitfacts/itemid_3599.pdf',
                                label: 'Using the Framingham score to predict heart attack risk'
                            },
                            {
                                link: '/images/webcontent/assets/education-resources/lifestyle/fitfacts/pdfs/fitfacts/itemid_3595.pdf',
                                label: 'Numbers to Know: Cholesterol'
                            },
                            {
                                link: '/images/webcontent/assets/education-resources/lifestyle/fitfacts/pdfs/fitfacts/itemid_3596.pdf',
                                label: 'Decreasing Stress'
                            },
                            {
                                link: '/images/webcontent/assets/education-resources/lifestyle/fitfacts/pdfs/fitfacts/itemid_3601.pdf',
                                label: 'Numbers to Know: Waist Circumference'
                            }
                        ]}
                    />
				</div>
			</div>
		</div>
	);
}
